// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search label {\n  font-size: 12px;\n  font-weight: normal;\n}\n.search .el-select {\n  width: 100%;\n}\n.search .el-dialog__footer {\n  min-height: 45px;\n}\n", ""]);
// Exports
module.exports = exports;
